var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1SmartphoneSensor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.77 37a36.53 36.53 0 01-9 24.07l-3-2.63a32.58 32.58 0 000-42.88l3-2.63a36.53 36.53 0 019 24.07zM53.14 19.34L50 21.78a24.95 24.95 0 010 30.44l3.17 2.44a29 29 0 000-35.32h-.03zm-3.36 8l-3.59 1.77a17.88 17.88 0 010 15.76l3.59 1.77a21.91 21.91 0 000-19.3zM41 19v38a4 4 0 01-4 4H17a4 4 0 01-4-4V19a4 4 0 014-4h20a4 4 0 014 4zm-4 0H17v38h20V19zM27 52.5a2 2 0 100-3.999 2 2 0 000 4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Smartphone_sensor.7a994370.svg";
export { SvgH1SmartphoneSensor as ReactComponent };